export function generateHalfHourIncrements(openingTime?: string, closingTime?: string): string[] {
    openingTime = openingTime || '0800';
    closingTime = closingTime || '1700';

    const increments: string[] = [];
    let currentTime = openingTime;

    while (currentTime <= closingTime) {
        increments.push(currentTime);
        const hours = Number(currentTime.substr(0, 2));
        const minutes = Number(currentTime.substr(2, 2));

        if (minutes === 30) {
            currentTime = `${(hours + 1).toString().padStart(2, '0')}00`;
        } else {
            currentTime = `${hours.toString().padStart(2, '0')}${(minutes + 30).toString().padStart(2, '0')}`;
        }
    }

    return increments;
}
